import { styled, CSS } from '@grupoboticario/flora-react'

export const StyledCardImage = styled('img', {
  width: '60px',
  height: '60px',
  flexShrink: 0,
  marginRight: '$4',
  objectFit: 'cover',
  borderRadius: '$large'
})

export const StyledCardImagePlaceholder = styled('div', {
  width: '60px',
  height: '60px',
  flexShrink: 0,
  marginRight: '$4',
  borderRadius: '$large',
  backgroundColor: '$nonInteractiveOutline'
})

export const StyledCardContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0
})

export const StyledCardActions = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '$3',
  marginTop: '$3'
})

export const previewCardCss: CSS = {
  width: '300px',
  display: 'flex',
  flexDirection: 'row',
  borderRadius: '$medium',
  padding: '$4'
}

export const titleTypographyCss: CSS = {
  wordWrap: 'break-word',
  overflowWrap: 'break-word'
}

export const descriptionTypographyCss: CSS = {
  marginTop: '$3',
  wordWrap: 'break-word',
  '& strong, & b': { fontWeight: 'bold' },
  '& em, & i': { fontStyle: 'italic' }
}

export const rulesLinkCss: CSS = {
  border: 'none',
  cursor: 'default'
}
